import {Fragment} from 'react';

const Title: (props: any) => JSX.Element = (props: any) => {

    const {title, description, hide} = props;

    return (
        <Fragment>
            {title && description &&
                <div className="flex flex-col gap-4">
                    <div className="text-[26px] lg:text-[42px] uppercase">
                        {!hide && <span className="font-bold text-pomegranate-300">Auswahl</span>} <span className="text-pomegranate-200">{title}</span>
                    </div>
                    <div className="font-regular text-[14px] lg:text-[26px]">
                        {description}
                    </div>
                </div>
            }
        </Fragment>
    );
}

export default Title;
